export const MINDBODY_EVENTS = {
  classBookingCreated: 'classRosterBooking.created',
}
